import React from 'react';
import { useSelector } from 'react-redux';
import { getMarkup } from '../../../../utils/Utils';
import useNewChatbotBody from '../hooks/useNewChatbotBody';

const NewPrevQuestionPanel = () => {
    const chatBotNewState = useSelector(state => state.chatBotNew);
    const { answeredQuestions, flatQuestions } = chatBotNewState;
    const { handleEditPreviousQuestion } = useNewChatbotBody();

    if (!answeredQuestions || answeredQuestions.length === 0) return null;

    const lastAnswered = answeredQuestions[answeredQuestions.length - 1];
    const flatIndex = flatQuestions.findIndex(q => q.questionId === lastAnswered?.questionId);

    const getAnswerDisplayText = (question) => {
        if (!question) return '';
        const { responseType, answerId, answerValue, answerList, responses } = question;

        if ((responseType === 'CHECKBOX' || responseType === 'MULTISELECT') && answerList?.length > 0) {
            return answerList
                .map(id => {
                    const found = responses?.find(r => (r.AnswerId || r.id) === id);
                    return found?.AnswerTitle || found?.name || found?.answerTitle || '';
                })
                .filter(Boolean)
                .join(', ');
        }
        if (answerId && responses?.length > 0) {
            const found = responses.find(r => (r.AnswerId || r.id) === answerId);
            if (found) return found.AnswerTitle || found.name || found.answerTitle;
        }
        return answerValue || '';
    };

    const answerText = getAnswerDisplayText(lastAnswered);

    return (
        <div className="prev-question-section prev-question-section--spacing">
            <div className="prev-question prev-question--relative">
                {/*{(lastAnswered?.groupName || lastAnswered?.header1) && (*/}
                {/*    <div className="heading">*/}
                {/*        <span className="mmh-text-left">*/}
                {/*            {lastAnswered?.groupName && <span>{lastAnswered.groupName}</span>}*/}
                {/*            {lastAnswered?.header1 && (*/}
                {/*                <>*/}
                {/*                    <i className="fas fa-chevron-right" style={{ margin: '0 0.5rem' }} />*/}
                {/*                    <span>{lastAnswered.header1}</span>*/}
                {/*                </>*/}
                {/*            )}*/}
                {/*        </span>*/}
                {/*    </div>*/}
                {/*)}*/}
                <p className="edit-question edit-question--mb">
                    If you would like to edit your response to the last question, press edit
                </p>
                <div className="displayFlex justify-center w-100-percent">
                    <div className="prev-question__container displayFlex justify-between prev-question__container--grow w-100-percent">
                        <div className="displayFlex mmh-align-items-center prev-question__text-container">
                            <span
                                className="prev-question__dialogue"
                                dangerouslySetInnerHTML={getMarkup(lastAnswered?.text || lastAnswered?.questionTitle || '')}
                            />
                        </div>
                        {answerText && (
                            <div className="answer-container answer-container--ml">
                                <div className="answer answer--padding chatbot-prev-answer color-white">
                                    <div className="displayFlex answer__content--overflow mmh-align-items-center">
                                        <div className="displayFlex justify-center mmh-align-items-center">
                                            <i className="fa fa-check icon--mr padding-right-1-rem" />
                                        </div>
                                        <div className="answer-text answer-text--overflow">
                                            {answerText?.length > 30 ? answerText.substring(0, 27).trim() + '...' : answerText}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="answer answer--padding color-white edit chat-bot-edit-btn"
                                    onClick={() => handleEditPreviousQuestion(flatIndex)}
                                >
                                    <span className="answer__edit-text--ml white-space-pre">Edit</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewPrevQuestionPanel;
